import "../../css/FloatingSearch.css";
import { Label, Search } from "semantic-ui-react";
import React, { useEffect, useRef, useState } from "react";
import {
  filterGpsVehicles,
  getVehicleJob,
  fetchBatchVehicleJobs,
  missionControlSearch,
} from "../../api/missioncontrolApi";
import { useDispatch, useSelector } from "react-redux";
import { missionControlActions } from "../../store/mission-control/mission-control-slice";
import ResultOptions from "./SearchFilter/ResultOptions";
import Modal from "../Modal";
import { errorMessageToast } from "../../helper";

const resultRenderer = (prop, onResultSelect, onAdd) => {
  return (
    <Label
      style={{ width: "100%" }}
      onClick={(e) => {
        e.stopPropagation();
        onResultSelect({
          value: prop.value,
          title: prop.title,
          category: prop.category,
        });
      }}
      content={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ cursor: "pointer" }}>{prop.title}</div>
          <button
            className="circular ui icon button primary"
            style={{
              height: "5px",
              width: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              onAdd({
                value: prop.value,
                title: prop.title,
                category: prop.category,
              });
            }}
          >
            <i className="small plus icon"></i>
          </button>
        </div>
      }
    />
  );
};

const FloatingSearch = ({
  placeholder = "Search Jobs, Stakeholder, Destinations",
  threshold = 3,
  style,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setResultsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [dataList, setDataList] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [currentValue, setCurrentValue] = useState("");
  const [resultsOpen, setResultsOpen] = useState(false);
  const [results, setResults] = useState([]);
  const modalRef = useRef(null);

  const closeModal = () => {
    modalRef.current.close();
  };

  const markerLimit = useSelector(
    (state) => state.missionControl.mapSettings.markerLimit,
  );

  const searchRef = useRef();

  const handleSearchChange = async (e, data) => {
    setCurrentValue(data.value);
    if (data.value.length >= threshold) {
      setSearchLoading(true);
      const response = await missionControlSearch(data.value);
      setDataList(response);
      setResultsOpen(true);
      setSearchLoading(false);
    }
  };

  const onAddHandler = (data) => {
    dispatch(
      missionControlActions.addToSearchFilter({
        type: data.category,
        key: data.value,
        value: data.title,
      }),
    );
  };

  const onResultSelect = async (data) => {
    setCurrentValue(data.title);
    setSearchLoading(true);
    const response = await filterGpsVehicles({
      [data.category]: data.value,
      eventType: "",
    });
    if (response && response.length > markerLimit) {
      setResults(response);
      modalRef.current?.showModal();
    } else {
      const jobInfo = await fetchBatchVehicleJobs(response);
      dispatch(
        missionControlActions.setResults({
          results: response,
          jobInfo,
        }),
      );
    }
    setResultsOpen(false);
    setSearchLoading(false);
  };

  return (
    <>
      <style>
        {`        
                  .search-dropdown > .input {
                    width: 100%;
                    border: none;
                    border-radius: 25px;
                    background-color: white;
                    outline: none;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1),
                    0 6px 20px rgba(0, 0, 0, 0.1);
                  }

                  .search-dropdown .results {
                    max-height: 700px;
                    width: 500px;
                    overflow-y: auto;
                  }
              
                  .ui.category.search .results {
                    width: 480px;
                  }
              `}
      </style>
      <Modal ref={modalRef} minWidth="1100px" closeButton={true}>
        <ResultOptions results={results} close={closeModal} />
      </Modal>
      <div className="floating-search-container" style={style} ref={searchRef}>
        <div className="floating-search">
          <Search
            className="floating-search-input search-dropdown"
            type="text"
            loading={searchLoading}
            resultRenderer={(props) =>
              resultRenderer(props, onResultSelect, onAddHandler)
            }
            category
            placeholder={placeholder}
            open={resultsOpen}
            onResultSelect={(e, data) => {
              e.preventDefault();
              onResultSelect(data.result);
            }}
            onSearchChange={handleSearchChange}
            results={dataList}
            value={currentValue}
          />
        </div>
      </div>
    </>
  );
};

export default FloatingSearch;
